exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-alpecin-js": () => import("./../../../src/pages/alpecin.js" /* webpackChunkName: "component---src-pages-alpecin-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-plantur-js": () => import("./../../../src/pages/plantur.js" /* webpackChunkName: "component---src-pages-plantur-js" */)
}

